const profileroutes = {
  path: "/profile",
  name: "profile",
  component: () => import("@/view/pages/profile/Profile.vue")
};

export default profileroutes;
